import {
    RadioButtonProps as PrimeRadioButtonProps,
    RadioButton as PrimereactRadioButton,
} from 'primereact/radiobutton';
import { forwardRef, ReactNode, Ref } from 'react';

export { RadioButton as PrimeRadioButton } from 'primereact/radiobutton';

export type RadioButtonProps = PrimeRadioButtonProps & {
    toggleable?: boolean;
    onCheckedChange?: (checked: boolean) => void;
};

function RadioButtonComponent(
    props: RadioButtonProps,
    ref: Ref<PrimereactRadioButton>,
): ReactNode {
    const {
        checked = false,
        disabled,
        readOnly,
        toggleable = false,
        onChange,
        onCheckedChange,
        onClickCapture,
        ...radioProps
    } = props;

    return (
        <PrimereactRadioButton
            {...radioProps}
            ref={ref}
            checked={checked}
            disabled={disabled}
            readOnly={readOnly}
            onChange={(event) => {
                onChange?.(event);
                onCheckedChange?.(event.checked ?? false);
            }}
            onClickCapture={(event) => {
                onClickCapture?.(event);
                if (
                    event.defaultPrevented ||
                    !toggleable ||
                    !checked ||
                    disabled ||
                    readOnly
                )
                    return;

                event.preventDefault();
                event.stopPropagation();
                onCheckedChange?.(false);
            }}
        />
    );
}

export const RadioButton = forwardRef(RadioButtonComponent);
